import { FaPencilAlt, FaTrashAlt } from 'react-icons/fa'

import { Add } from '@mui/icons-material'
import bg from 'date-fns/esm/locale/bg'
import de from 'date-fns/esm/locale/de'
import en from 'date-fns/esm/locale/en-US'
import { t } from 'i18next'
import _ from 'lodash'
import { format } from 'date-fns'

import {
  AssessmentType,
  AttendanceStatusType,
  DocumentStatusType,
  EnrollmentStatusType,
  SessionStatusType,
  GradebookViewType,
  GenderType,
  INestedItems,
  RoleType,
  ScoreType,
  SubmissionType,
  MeetingsType,
  MeetingsStatusType,
  RecipientsType,
  EmergencyContactType,
  MaritalStateType,
  SchoolLevelType,
  SchoolCurriculumType,
  SchoolTypeType,
  RtiInterventionStatusType,
  FrequencyType,
  SyllabusExpectationAmountType,
  SyllabusExpectationFrequencyType,
  AdjustmentTypeType,
  ContentAreaType,
  GradingType,
  KnowledgeType,
  ZpdTag,
  Kpi,
  ZpdAnchor,
  ExpectedTimeType,
} from 'types'
import { 
  usePOST_highlightMutation,
  useDELETE_highlightMutation,
  usePOST_sloMutation, 
  useDELETE_sloMutation,
  usePOST_measureMutation, 
  useDELETE_measureMutation,
  usePOST_topicMutation, 
  useDELETE_topicMutation,
  usePOST_skillMutation, 
  useDELETE_skillMutation,
  usePOST_courseChapterObjectiveMutation, 
  useDELETE_courseChapterObjectiveMutation,
  usePOST_fluencyMutation, 
  useDELETE_fluencyMutation,
  usePOST_practiceMutation, 
  useDELETE_practiceMutation,
  usePOST_successCriteriaMutation, 
  useDELETE_successCriteriaMutation,
  usePOST_goalbankQuestionMutation,
  useDELETE_goalbankQuestionMutation,
  usePOST_goalbankUnderstandingMutation,
  useDELETE_goalbankUnderstandingMutation,
  usePOST_goalbankLessonMutation,
  useDELETE_goalbankLessonMutation,
  usePOST_goalbankActivityMutation,
  usePOST_goalbankResourceMutation,
  useDELETE_goalbankResourceMutation,
} from 'redux/api/goalbankApi'
import i18n from 'i18n'


export const USER_ROLES: RoleType[] = [
  'admin',
  'principal',
  'vice_principal',
  'staff_administrator',
  'teacher',
  'special_teacher',
  'nurse',
  'auditor',
  'student',
  'parent',
]


export const GOALBANK_ITEM_TYPES = {

  
  section_a: {title: t('goalbank-more.section-1'), type: "choices", display_code: false, code_field: null, has_description: false, addHook: null, deleteHook: null},
  section_b: {title: t('goalbank-more.section-2'), type: "choices", display_code: false, code_field: null, has_description: false, addHook: null, deleteHook: null},
  section_c: {title: t('goalbank-more.section-3'), type: "choices", display_code: false, code_field: null, has_description: false, addHook: null, deleteHook: null},
  section_d: {title: t('goalbank-more.section-4'), type: "choices", display_code: false, code_field: null, has_description: false, addHook: null, deleteHook: null},

  units: {title: t('goalbank.units'), type: "units", display_code: false, code_field: null, has_description: false, addHook: null, deleteHook: null},

  clusters: {title: t('goalbank.clusters'), type: "choices", display_code: false, code_field: "display_code",  has_description: true, addHook: null, deleteHook: null},
  goals: {title: t('goalbank.goals'), type: "choices", display_code: false, code_field: "display_code", has_description: true, addHook: null, deleteHook: null},

  course_chapters: {title: t('goalbank.units'), type: "course_chapters", display_code: true, code_field: null, has_description: false, addHook: usePOST_courseChapterObjectiveMutation, deleteHook: useDELETE_courseChapterObjectiveMutation},
  highlights: {title: t('common.highlights'), type: "choices", display_code: false, code_field: null, has_description: false, addHook: usePOST_highlightMutation, deleteHook: useDELETE_highlightMutation},
  student_learning_objectives: {title: t('goalbank.slo'), type: "choices", display_code: true, code_field: null, has_description: true, addHook: usePOST_sloMutation, deleteHook: useDELETE_sloMutation},
  measures: {title: t('goalbank.measures'), type: "choices", display_code: false, code_field: null, has_description: true, addHook: usePOST_measureMutation, deleteHook: useDELETE_measureMutation},
  
  goalbank_questions: {title: t('goalbank.essential-questions'), type: "choices", display_code: false, code_field: null, has_description: false, addHook: usePOST_goalbankQuestionMutation, deleteHook: useDELETE_goalbankQuestionMutation},
  goalbank_understandings: {title: t('goalbank.enduring-understandings'), type: "choices", display_code: false, code_field: null, has_description: false, addHook: usePOST_goalbankUnderstandingMutation, deleteHook: useDELETE_goalbankUnderstandingMutation},
  objectives: {title: t('goalbank.learning-progression'), type: "choices", display_code: false, code_field: null, has_description: true, addHook: null, deleteHook: null},

  goalbank_lessons: {title: t('goalbank.lessons'), type: "choices", display_code: false, code_field: ["sort_order"], has_description: true, addHook: usePOST_goalbankLessonMutation, deleteHook: useDELETE_goalbankLessonMutation},
  goalbank_activities: {title: t('goalbank.activities'), type: "choices", display_code: false, code_field: null, has_description: true, addHook: usePOST_goalbankActivityMutation, deleteHook: usePOST_goalbankActivityMutation},
  goalbank_exercises: {title: t('goalbank.exercises'), type: "choices", display_code: false, code_field: null, has_description: false, addHook: usePOST_goalbankLessonMutation, deleteHook: useDELETE_goalbankLessonMutation},

  topics: {title: t('goalbank.topics'), type: "choices", display_code: false, code_field: null, has_description: false, addHook: usePOST_topicMutation, deleteHook: useDELETE_topicMutation},
  skills: {title: t('goalbank.skills'), type: "choices", display_code: false, code_field: null, has_description: true, addHook: usePOST_skillMutation, deleteHook: useDELETE_skillMutation},
  fluencies: {title: t('goalbank.fluencies'), type: "choices", display_code: false, code_field: null, has_description: false, addHook: usePOST_fluencyMutation, deleteHook: useDELETE_fluencyMutation},
  practices: {title: t('goalbank.practices'), type: "choices", display_code: true, code_field: "code", has_description: false, addHook: usePOST_practiceMutation, deleteHook: useDELETE_practiceMutation},
  success_criterias: {title: t('goalbank.success-criteria'), type: "choices", display_code: false, code_field: null, has_description: false, addHook: usePOST_successCriteriaMutation, deleteHook: useDELETE_successCriteriaMutation},
  
  goalbank_resources: {title: t('goalbank.resources'), type: "choices", display_code: false, code_field: null, has_description: true, addHook: usePOST_goalbankResourceMutation, deleteHook: useDELETE_goalbankResourceMutation},


}


export const optionsYesNo = [
  {
    label: t('common.yes'),
    value: 1,
  },
  {
    label: t('common.no'),
    value: 0,
  }
]

export const optionsYesNoString = [
  {
    label: t('common.yes'),
    value: 'yes',
  },
  {
    label: t('common.no'),
    value: 'no',
  }
]


/**
 * @param item - {}
 * @param keys - 'machine.title'
 * @returns the value of items.machine.title
 */
export const getValueFromKeys = (item: { [key: string]: any }, keys: string): string => {
  const keysArray = keys ? keys.split('.') : []

  for (let i = 0; i < keysArray.length; i++) {
    const key = keysArray[i]
    if (item) {
      item = item[key]
    }
  }

  return item ? `${item}` : ''
}

/**
 * @param options - [{..., children: any}]
 * @info all the children are out of parent nesting
 * @info children key is remove and parents is set instead
 * @returns flatten array and remember parents
 */
export const deepFlattenAndRememberParents = (options: INestedItems[]): INestedItems[] => {
  let flatten = _.cloneDeep(options)

  for (let i = 0; i < flatten?.length; i++) {
    if (flatten[i].hasOwnProperty('children')) {
      flatten[i].children.map((child: any) => {
        if (flatten[i].hasOwnProperty('parents')) {
          child.parents = [...flatten[i].parents, flatten[i]]
        } else {
          child.parents = [flatten[i]]
        }
        return child
      })

      flatten.splice(i + 1, 0, ...flatten[i].children)
      delete flatten[i].children
    }

    if (!flatten[i].hasOwnProperty('parents')) {
      flatten[i].parents = []
    }
  }

  return flatten
}

export const deepFlatten = (array: INestedItems[]): INestedItems[] => {
  let flatten = _.cloneDeep(array)

  for (let i = 0; i < flatten?.length; i++) {
    if (flatten[i].hasOwnProperty('children')) {
      flatten.splice(i + 1, 0, ...flatten[i].children)
      delete flatten[i].children
    }
  }

  return flatten
}

export const downloadFile = (url, params) => {
  fetch(`${process.env.REACT_APP_BASE_URL}${url}?${new URLSearchParams(params).toString()}`,   
    {
      headers: new Headers({
          'Authorization': `Token ${window.localStorage.getItem('token')}`, 
      })
    }
  ) 
  .then( res => res.blob() )
  .then( blob => {
    var file = window.URL.createObjectURL(blob);
    window.location.assign(file);
  });
}

export const convertArrayToObject = (array, key, prefix) => {
  const initialValue = {};
  return array.reduce((obj, item) => {
    return {
      ...obj,
      [prefix + item[key]]: item,
    };
  }, initialValue);
};

export function parseDateTime (date) {
  if(!date)
    return new Date()
  const [ year, month, day ] = date.substr(0, 10).split('-')
  const [ hour, minute ] = date.substr(11, 5).split(':')
  return new Date(year, (month - 1), day, hour, minute)
}

export function formatDateTime (date) {
  try {
    return format(parseDateTime(date), 'dd-MM-yyyy HH:mm')
  } catch (error) {
    return ""
  }
}

export function formatTime(date) {
  try {
    return format(parseDateTime(date), 'HH:mm')
  } catch (error) {
    return ""
  }
}

export function formatDate (date) {
  try {
    return format(parseDateTime(date), 'dd-MM-yyyy')
  } catch (error) {
    return ""
  }
}

export function dayOfWeek(date){
  try {
   const orderedWeekdays = [6,0,1,2,3,4,5];
   return weekdays[orderedWeekdays[date.getDay()]];
  } catch (error) {
    return ""
  }
}

export function getDateStatus (date) {
   if(!date)return "today";

   const today = new Date();
   const todayFormat = format(today, 'yyyy-MM-dd')
 
   const dateTime = new Date(date)
   const dateFormat = format(dateTime, 'dd-MM-yyyy')

   if(todayFormat == dateFormat)return "today";
   if(dateTime < today)return "passed"; 
   return "future";
}

// Locale
export const locale = {
  bg,
  de,
  en,
}

// Weekdays
export const weekdays = [
  'monday',
  'tuesday',
  'wednesday',
  'thursday',
  'friday',
  'saturday',
  'sunday'
]

export const contentAreaSelectData = () => {
  const data: { id: ContentAreaType; title: string }[] = [
    { id: 'reading', title: t('content-areas.reading') },
    { id: 'writing', title: t('content-areas.writing') },
    { id: 'science', title: t('content-areas.science') },
    { id: 'social_studies', title: t('content-areas.social_studies') },
    { id: 'other', title: t('content-areas.other') },
  ]
  return {
    data: {
      list: data,
      count: data?.length,
      hasMore: false,
    },
  }
}

export const statusSelectData = (status: DocumentStatusType) => {
  const data: { id: DocumentStatusType; title: string; disabled?: boolean; hidden?: boolean }[] = [
    { id: 'draft', title: t('common.draft'), disabled: status === 'published' },
    { id: 'published', title: t('common.published') },
    { id: 'cancelled', title: t('common.cancelled') },
    { id: 'finished', title: t('common.finished'), hidden: true },
  ]
  return {
    data: {
      list: data,
      count: data?.length,
      hasMore: false,
    },
  }
}

export const attendanceStatusSelectData = () => {
  const data: { id: AttendanceStatusType; title: string; }[] = [
    { id: 'present', title: t('attendance.status-present') },
    { id: 'tardy', title: t('attendance.status-tardy') },
    { id: 'tardy_excused', title: t('attendance.status-tardy_excused') },
    { id: 'absent', title: t('attendance.status-absent') },
    { id: 'absent_excused', title: t('attendance.status-absent_excused') },

  ]
  return {
    data: {
      list: data,
      count: data?.length,
      hasMore: false,
    },
  }
}

export const enrollmentStatusSelectData = () => {
  const data: { id: EnrollmentStatusType; title: string;  }[] = [
    { id: 'pending', title: t('enrollment-status.pending') },
    { id: 'active', title: t('enrollment-status.active') },
    { id: 'cancelled', title: t('enrollment-status.cancelled') },
  ]
  return {
    data: {
      list: data,
      count: data?.length,
      hasMore: false,
    },
  }
}

export const sessionStatusSelectData = () => {
  const data: { id: SessionStatusType; title: string;  }[] = [
    { id: 'pending', title: t('session-status.pending') },
    { id: 'active', title: t('session-status.active') },
    { id: 'cancelled', title: t('session-status.cancelled') },
  ]
  return {
    data: {
      list: data,
      count: data?.length,
      hasMore: false,
    },
  }
}

export const gradebookViewSelectData = () => {
  const data: { id: GradebookViewType; title: string; }[] = [
    { id: 'assignments', title: t('common.assignments') },
    { id: 'course-components', title: t('common.course-components') },
    { id: 'final-grades', title: t('common.classroom-annual-grades') },
  ]
  return {
    data: {
      list: data,
      count: data?.length,
      hasMore: false,
    },
  }
}

export const zeroPad = (num: number, places: number) => {
  var zero = places - num.toString().length + 1;
  return Array(+(zero > 0 && zero)).join("0") + num;
}

export const timePickerSelectData = () => {
  let timePickerData = []
  _.range(14).forEach(h => {
    _.range(4).forEach(m => {
      const value = `${zeroPad(h+6,2)}:${zeroPad(m*15,2)}`
      timePickerData.push({id: value, title: value})
    })
  })

  return {
    data: {
      list: timePickerData,
      count: timePickerData?.length,
      hasMore: false,
    },
  }
}

export const minutesSelectData = () => {
  const data = _.range(60).map(m => {return {id: m, title: m}})

  return {
    data: {
      list: data,
      count: data?.length,
      hasMore: false,
    },
  }
}

export const genderSelectData = () => {
  const data: { id: GenderType; title: string }[] = [
    { id: 'male', title: t('common.male') },
    { id: 'female', title: t('common.female') },
  ]
  return {
    data: {
      list: data,
      count: data?.length,
      hasMore: false,
    },
  }
}

export const assessmentTypeSelectData = () => {
  const data: { id: AssessmentType; title: string }[] = [
    { id: 'formative', title: t('common.formative') },
    { id: 'summative', title: t('common.summative') },
    { id: 'diagnostic', title: t('common.diagnostic') },
  ]
  return {
    data: {
      list: data,
      count: data?.length,
      hasMore: false,
    },
  }
}

export const submissionTypeSelectData = () => {
  const data: { id: SubmissionType; title: string }[] = [
    { id: 'individual', title: t('submission-type.individual') },
    { id: 'group', title: t('submission-type.group') },
    { id: 'portfolio', title: t('submission-type.portfolio') },
  ]
  return {
    data: {
      list: data,
      count: data?.length,
      hasMore: false,
    },
  }
}

export const gradingTypeSelectData = () => {
  const data: { id: GradingType; title: string }[] = [
    { id: 'categories', title: t('grading-types.categories') },
    { id: 'assignments', title: t('grading-types.assignments') },
  ]
  return {
    data: {
      list: data,
      count: data?.length,
      hasMore: false,
    },
  }
}

export const scoreTypeSelectData = () => {
  const data: { id: ScoreType; title: string }[] = [
    { id: 'percentage', title: t('grade-scale.percentage') },
    { id: 'points', title: t('grade-scale.points') },
    { id: 'letters', title: t('grade-scale.letters') },
    { id: 'numbers', title: t('grade-scale.numbers') },
    { id: 'text', title: t('grade-scale.text') },
    { id: 'special', title: t('grade-scale.special') },
  ]
  return {
    data: {
      list: data,
      count: data?.length,
      hasMore: false,
    },
  }
}

export const recipientsTypeSelectData = () => {
  const data: { id: RecipientsType; title: string }[] = [
    { id: 'everyone', title: t('assignments.everyone-in-class') },
    { id: 'team', title: t('assignments.class-group') },
    { id: 'individuals', title: t('assignments.individual-students') },
  ]
  return {
    data: {
      list: data,
      count: data?.length,
      hasMore: false,
    },
  }
}


export const expectedTimeTypeSelectData = () => {
  const data: { id: ExpectedTimeType; title: string }[] = [
    { id: 'minutes', title: t('common.minutes') },
    { id: 'hours', title: t('common.hours') },
    { id: 'days', title: t('common.days') },
  ]
  return {
    data: {
      list: data,
      count: data?.length,
      hasMore: false,
    },
  }
}

export const rtiInterventionStatusSelectData = () => {
  const data: { id: RtiInterventionStatusType; title: string }[] = [
    { id: 'pending', title: t('rti-intervention-status.pending') },
    { id: 'active', title: t('rti-intervention-status.active') },
    { id: 'holding', title: t('rti-intervention-status.holding') },
    { id: 'interrupted', title: t('rti-intervention-status.interrupted') },
    { id: 'passive', title: t('rti-intervention-status.passive') },
  ]
  return {
    data: {
      list: data,
      count: data?.length,
      hasMore: false,
    },
  }
}

export const adjustmentTypeSelectData = () => {
  const data: { id: AdjustmentTypeType; title: string }[] = [
    { id: 'accommodation', title: t('common.accommodation') },
    { id: 'modification', title: t('common.modification') },
  ]
  return {
    data: {
      list: data,
      count: data?.length,
      hasMore: false,
    },
  }
}

export const frequencySelectData = () => {
  const data: { id: FrequencyType; title: string }[] = [
    { id: 'weekly', title: t('common.weekly') },
    { id: 'monthly', title: t('common.monthly') },
  ]
  return {
    data: {
      list: data,
      count: data?.length,
      hasMore: false,
    },
  }
}



export const knowledgeTypeSelectData = () => {
  const data: { id: KnowledgeType; title: string }[] = [
    { id: 'factual', title: t('knowledge-types.factual') },
    { id: 'conceptual', title: t('knowledge-types.conceptual') },
    { id: 'procedural', title: t('knowledge-types.procedural') },
    { id: 'metacognitive', title: t('knowledge-types.metacognitive') },
  ]
  return {
    data: {
      list: data,
      count: data?.length,
      hasMore: false,
    },
  }
}

export const zpdTagSelectData = () => {
  const data: { id: ZpdTag; title: string }[] = [
    { id: 'strength', title: t('zpd-tags.strength') },
    { id: 'bridge', title: t('zpd-tags.bridge') },
    { id: 'gap', title: t('zpd-tags.gap') },
  ]
  return {
    data: {
      list: data,
      count: data?.length,
      hasMore: false,
    },
  }
}

export const zpdAnchorSelectData = () => {
  const data: { id: ZpdAnchor; title: string }[] = [
    { id: 'emerging', title: t('zpd-anchors.emerging') },
    { id: 'developing', title: t('zpd-anchors.developing') },
    { id: 'mastering', title: t('zpd-anchors.mastering') },
  ]
  return {
    data: {
      list: data,
      count: data?.length,
      hasMore: false,
    },
  }
}

export const kpiSelectData = () => {
  const data: { id: Kpi; title: string }[] = [
    { id: 'acc', title: t('kpi.acc') },
    //{ id: 'err', title: t('kpi.err') },
    { id: 'time', title: t('kpi.time') },
    { id: 'grow', title: t('kpi.grow') },
  ]
  return {
    data: {
      list: data,
      count: data?.length,
      hasMore: false,
    },
  }
}

export const rtiTierSelectData = () => {
  const data = Array.from({ length: 3 }).map((el, i) => ({ id: i + 1, title: `${t('rti.tier')} ${i + 1}` }))
  return {
    data: {
      list: data,
      count: data?.length,
      hasMore: false,
    },
  }
}

export const rtiGroupSizeSelectData = () => {
  const data = Array.from({ length: 3 }).map((el, i) => ({ id: i + 1, title: `${t('rti-group-size.group-size-'+(i+1))}` }))
  return {
    data: {
      list: data,
      count: data?.length,
      hasMore: false,
    },
  }
}

export const rtiRiskCriteriaTypeData = () => {
  const data = Array.from({ length: 3 }).map((el, i) => ({ id: i + 1, title: `${t('rti.rti-risk-criteria')} ${i + 1}` }))
  return {
    data: {
      list: data,
      count: data?.length,
      hasMore: false,
    },
  }
}

export const translateGradeLevel = (grade_level, isCode = false) => {
  if(isCode)
    return parseInt(grade_level) > 0 ? `${grade_level}` : (i18n.language == "pt" ? "PE" : "K")

  if(i18n.language == "pt"){
    return parseInt(grade_level) > 0 ? `${grade_level}.º ${t('common.grade-number')}` : t('common.kindergarten')
  }
  
  return parseInt(grade_level) > 0 ? `${t('common.grade-number')} ${grade_level}` : t('common.kindergarten')
}

export const rubricLevelsSelectData = () => {
  const data = Array.from({ length: 5 }).map((el, i) => ({ id: (i+1), title: (i+1).toString() }))
  return {
    data: {
      list: data,
      count: data?.length,
      hasMore: false,
    },
  }
}

export const rubricPointsSelectData = () => {
  const data = Array.from({ length: 10 }).map((el, i) => ({ id: (i+1)*10, title: ((i+1)*10).toString() }))
  return {
    data: {
      list: data,
      count: data?.length,
      hasMore: false,
    },
  }
}


export const gradeSelectData = (filters = {}) => {
  let data = Array.from({ length: 13 }).map((el, i) => ({ id: i, title: `${translateGradeLevel(i, true)}` }))
  if("data" in filters){
    const availableGradeLevels = filters["data"] as any
    data = data.filter(item => availableGradeLevels.includes(item.id))
  }

  return {
    data: {
      list: data,
      count: data?.length,
      hasMore: false,
    },
  }
}

export const gradeSelectDataFull = () => {
  const data = Array.from({ length: 13 }).map((el, i) => ({ id: i, title: `${translateGradeLevel(i)}` }))
  return {
    data: {
      list: data,
      count: data?.length,
      hasMore: false,
    },
  }
}

export const unitNumberSelectData = () => {
  const data = Array.from({ length: 24 }).map((el, i) => ({ id: i + 1, title: `${i + 1}` }))
  return {
    data: {
      list: data,
      count: data?.length,
      hasMore: false,
    },
  }
}

export const dokLevelSelectData = () => {
  const data = Array.from({ length: 4 }).map((el, i) => ({ id: i + 1, title: `${i + 1}` }))
  return {
    data: {
      list: data,
      count: data?.length,
      hasMore: false,
    },
  }
}

export const lessonNumberSelectData = () => {
  const data = Array.from({ length: 100 }).map((el, i) => ({ id: i + 1, title: `${i + 1}` }))
  return {
    data: {
      list: data,
      count: data?.length,
      hasMore: false,
    },
  }
}

export const unitDurationSelectData = () => {
  const data = Array.from({ length: 12 }).map((el, i) => ({ id: i + 1, title: `${i + 1}` }))
  return {
    data: {
      list: data,
      count: data?.length,
      hasMore: false,
    },
  }
}

export const unitPeriodData =  [
  {id: 'week', title: t('common.weeks')},
  {id: 'month', title: t('common.months')}
]
export const unitPeriodSelectData = () => {
  return {
    data: {
      list: unitPeriodData,
      count: unitPeriodData?.length,
      hasMore: false,
    },
  }
}

export const termSelectData = () => {
  const data = Array.from({ length: 4 }).map((el, i) => ({ id: i + 1, title: `${i + 1}` }))
  return {
    data: {
      list: data,
      count: data?.length,
      hasMore: false,
    },
  }
}

export const academicYearSelectData = () => {
  const data = Array.from({ length: 3 }).map((el, i) => ({ id: i + 2023, title: `${i + 2023} / ${i + 2024}` }))
  return {
    data: {
      list: data,
      count: data?.length,
      hasMore: false,
    },
  }
}

export const weightSelectData = () => {
  const data = Array.from({ length: 10 }).map((el, i) => ({ id: i + 1, title: `${i + 1}` }))
  return {
    data: {
      list: data,
      count: data?.length,
      hasMore: false,
    },
  }
}

export const attemptsSelectData = () => {
  const data = Array.from({ length: 3 }).map((el, i) => ({ id: i + 1, title: `${i + 1}` }))
  return {
    data: {
      list: data,
      count: data?.length,
      hasMore: false,
    },
  }
}


export const printDiv = (id) => {
  const printContents = document.getElementById(id).innerHTML;
  const w = window.open();
  w.document.write(`<html><head><meta charset="utf-8" />
    <style>
      body{font-size: 14px;}
      button{display: none;}
      .border-table{border-collapse: collapse; width: 100%;font-size: 14px;}
      .border-table th{padding: 10px; font-weight: bold; background: #f5f5f5; border: 1px solid #000;}
      .border-table td{padding: 10px; border: 1px solid #000;}

      .checklist-table{
        border-collapse: collapse;
        width: 100%;
        font-size: 12px;
        text-align: left;
      }
      .checklist-table th{
        background: #ebebeb;
        font-weight: 600;
        font-size: 12px;
      }
      .checklist-table td{
        background: #fff;
        font-size: 14px;
      }
      .checklist-table td, .checklist-table th{
        padding: 10px;
        border: 1px solid #ccc;
      }
    </style>
  </head><body>${printContents}</body></html>`)  
  w.print();
  w.close();
}

export const openContent = (content) => {
  const w = window.open();
  w.document.write(content)  
}

export const titleToSlug = (title) => {
  return title.toLowerCase().replaceAll(' ','-');
}
//Crud actions map

export const crudActionsMap = {
  view: 'view',
  add: 'add',
  edit: 'edit',
  delete: 'delete',
}

export const crudColorMap = {
  view: 'primary',
  add: 'success',
  edit: 'success',
  delete: 'error',
}

export const crudIconMap = {
  view: <></>,
  add: (
    <Add style={{ fontSize: '1.5rem', marginRight: '0.25rem', marginLeft: '-0.5rem', marginTop: '-1px' }} />
  ),
  edit: <FaPencilAlt style={{ fontSize: '1.1rem', marginRight: '0.5rem', marginLeft: '-0.5rem' }} />,
  delete: (
    <FaTrashAlt
      style={{ fontSize: '1.2rem', marginRight: '0.5rem', marginLeft: '-0.5rem', marginTop: '-3px' }}
    />
  ),
}

export const meetingsStatusSelectData = () => {
  const data: { id: MeetingsStatusType; title: string }[] = [
    { id: 'pending', title: t('enrollment-status.pending') },
    { id: 'active', title: t('enrollment-status.active') },
    { id: 'finished', title: t('common.finished') },
    { id: 'cancelled', title: t('common.cancelled') },
  ]
  return {
    data: {
      list: data,
      count: data?.length,
      hasMore: false,
    },
  }
}
export const meetingsTypeSelectData = () => {
  const data: { id: MeetingsType; title: string }[] = [
    { id: 'online', title: t('meetings.online') },
    { id: 'in_person', title: t('meetings.in-person') },
  ]
  return {
    data: {
      list: data,
      count: data?.length,
      hasMore: false,
    },
  }
}

export const emergencyContactTypeSelectData = () => {
  const data: { id: EmergencyContactType; title: string }[] = [
    { id: 'husband', title: t('emergency-contact.husband') },
    { id: 'wife', title: t('emergency-contact.wife') },
    { id: 'child', title: t('emergency-contact.child') },
    { id: 'mother', title: t('emergency-contact.mother') },
    { id: 'father', title: t('emergency-contact.father') },
    { id: 'brother', title: t('emergency-contact.brother') },
    { id: 'sister', title: t('emergency-contact.sister') },
    { id: 'relative', title: t('emergency-contact.relative') },
    { id: 'neighbor', title: t('emergency-contact.neighbor') },
    { id: 'friend', title: t('emergency-contact.friend') },
  ]
  return {
    data: {
      list: data,
      count: data?.length,
      hasMore: false,
    },
  }
}

export const maritalStateSelectData = () => {
  const data: { id: MaritalStateType; title: string }[] = [
    { id: 'single', title: t('marital-state.single') },
    { id: 'married', title: t('marital-state.married') },
    { id: 'divorced', title: t('marital-state.divorced') },
    { id: 'widowed', title: t('marital-state.widowed') },
  ]
  return {
    data: {
      list: data,
      count: data?.length,
      hasMore: false,
    },
  }
}

export const syllabusExpectationAmountTypeSelectData = () => {
  const data: { id: SyllabusExpectationAmountType; title: string }[] = [
    { id: 'per_year', title: t('period-types.per-year') },
    { id: 'per_term', title: t('period-types.per-term') },
  ]
  return {
    data: {
      list: data,
      count: data?.length,
      hasMore: false,
    },
  }
}

export const syllabusExpectationFrequencyTypeSelectData = () => {
  const data: { id: SyllabusExpectationFrequencyType; title: string }[] = [
    { id: 'per_month', title: t('period-types.per-month') },
    { id: 'per_week', title: t('period-types.per-week') },
    { id: 'per_day', title: t('period-types.per-day') },
  ]
  return {
    data: {
      list: data,
      count: data?.length,
      hasMore: false,
    },
  }
}

export const schoolCurriculumSelectData = () => {
  const data: { id: SchoolCurriculumType; title: string }[] = [
    { id: 'ccss', title: t('school-curriculum.ccss') },
    { id: 'nic', title: t('school-curriculum.nic') },
    { id: 'ieyc', title: t('school-curriculum.ieyc') },
    { id: 'ipc', title: t('school-curriculum.ipc') },
    { id: 'imyc', title: t('school-curriculum.imyc') },
    { id: 'mc', title: t('school-curriculum.mc') },
  ]
  return {
    data: {
      list: data,
      count: data?.length,
      hasMore: false,
    },
  }
}

export const plopPointsChoices = () => {
  const data = 
    ['0','1','2','3','4'].map(p => { return {value: p, label: t(`plop-point-options.${p}`)} })
  return data
}

export const plopImportanceSelectData = () => {
  const data: { id: string; title: string }[] = 
    ['1','2','3'].map(p => { return {id: p, title: p+' - '+t(`plop-importance-options.${p}`)} })
  return {
    data: {
      list: data,
      count: data?.length,
      hasMore: false,
    },
  }
}

export const schoolAcademicPeriodsPerYearSelectData = () => {
  const data: { id: string; title: string }[] = 
    ['1','2','3','4'].map(p => { return {id: p, title: p} })
  return {
    data: {
      list: data,
      count: data?.length,
      hasMore: false,
    },
  }
}

export const schoolTypeSelectData = () => {
  const data: { id: SchoolTypeType; title: string }[] = [
    { id: 'mainstream', title: t('school-type.mainstream') },
    { id: 'mainstream-special', title: t('school-type.mainstream-special') },
    { id: 'inclusive', title: t('school-type.inclusive') },
  ]
  return {
    data: {
      list: data,
      count: data?.length,
      hasMore: false,
    },
  }
}

export const schoolLevelSelectData = () => {
  const data: { id: SchoolLevelType; title: string }[] = [
    { id: 'preschool', title: t('school-level.preschool') },
    { id: 'primary', title: t('school-level.primary') },
    { id: 'secondary', title: t('school-level.secondary') },
  ]
  return {
    data: {
      list: data,
      count: data?.length,
      hasMore: false,
    },
  }
}

export const selectYesNo = () => {
  const data: { id: string; title: string }[] = optionsYesNoString.map(o => { return {
    id: o.value,
    title: o.label
  }})

  return {
    data: {
      list: data,
      count: data?.length,
      hasMore: false,
    },
  }
}

export const goalbankSelectionStandards = (selection) => {
  return Object.keys(selection).map(g => selection[g].display_code)
}

export const goalbankSelectionItems = (selection, type) => {
  if(!selection)return []
  let allItems = []
  Object.keys(selection).forEach(g => {
    if(type in selection[g]["selection"])
      allItems=allItems.concat(selection[g]["selection"][type])
  })
  return _.uniqBy(allItems,"id")
}


export const goalbankSelectionRemoveItem = (selection, type, id) => {
  if(!selection)return {}

  let newSelection = _.cloneDeep(selection)
  Object.keys(newSelection).forEach(g => {
    if(type in newSelection[g]["selection"]){
      if(newSelection[g]["selection"][type].type==='units'){
        Object.keys(newSelection[g]["selection"][type]).forEach(u => {
          newSelection[g]["selection"][type][u]["objectives"]=
            newSelection[g]["selection"][type][u]["objectives"].filter(item => item.id !== id)
        })
      }
      else
        newSelection[g]["selection"][type]=newSelection[g]["selection"][type].filter(item => item.id !== id)
    } 
  })
  return newSelection
}

export function toHtml(dirty) {
  return { __html: dirty };
}

export function isSmallStudent(user){
  return user?.student_profile?.grade_level < 5 
}

export function isImage(url){
  const imageExtensions = ['png','jpg','jpeg'];
  return imageExtensions.filter(ext => {
    return url.toLowerCase().indexOf(ext) > 0
  }).length > 0
}

export function shuffleArray(array) {
  let currentIndex = array.length;

  // While there remain elements to shuffle...
  while (currentIndex != 0) {

    // Pick a remaining element...
    let randomIndex = Math.floor(Math.random() * currentIndex);
    currentIndex--;

    // And swap it with the current element.
    [array[currentIndex], array[randomIndex]] = [
      array[randomIndex], array[currentIndex]];
  }
}

export function removeEmpty(obj) {
  return Object.keys(obj)
    .filter(function (k) {
      return obj[k] != null && obj[k] != "";
    })
    .reduce(function (acc, k) {
      acc[k] = obj[k];
      return acc;
    }, {});
}

export function getActiveFilters(tableFilters:any, state: any){
  const activeFilters = []  
  Object.keys(tableFilters).filter(field => field !== "search").forEach(field => {
    if(Array.isArray(tableFilters[field])){
      if (state.tableFilters[field].length !== 0) {
        activeFilters.push(field)
      }
    }else{
      if (state.tableFilters[field] !== tableFilters[field]) {
        activeFilters.push(field)
      }
    }

  })
  return activeFilters
}